import _ from 'lodash';
import Raven from 'raven-js';
import Bowser from 'bowser';
import type { Account } from '@patsnap-utils/biz';
import type { TrackEventPayload } from 'services/raven-service/raven-service';
import { create } from '@patsnap/tahiti-core';

export const sentryDeferred = create<void>();

declare module 'raven-js' {
    export interface RavenStatic {
        insertMeta(data: unknown): void
    }
}

interface ITrackData {
    attr: unknown
}

let _region: string;

let unpushedTrackEventsStack: ITrackData[] = [];

function getSiteRegion() {
    return _region;
}

function setSiteRegion(value: string) {
    _region = value;
}

function getCookie(cookieName: string) {
    const strCookie = document.cookie;
    const arrCookie = strCookie.split('; ');
    for (let i = 0; i < arrCookie.length; i += 1) {
        const arr = arrCookie[i].split('=');
        if (cookieName === arr[0]) {
            return arr[1];
        }
    }
    return '';
}

function loadPsTracer(page: string) {
    // @ts-ignore
    import(/* webpackChunkName: "common-ps-tracer" */'@patsnap/common-ps-tracer')
        .then(m => (m.default ? m.default : m))
        .then((sentryPsPlugin: Raven.RavenPlugin) => {
            sentryPsPlugin(Raven, {
                product: 'TELECOM',
                page: page,
                openSpendTimeTrack: true,
            });
            sentryDeferred.resolve();
        })
        .then(() => {
            unpushedTrackEventsStack.forEach(trackData => {
                trackData.attr = _.merge(trackData.attr, {
                    region: getSiteRegion(),
                });
                Raven.insertMeta(trackData);
            });
            unpushedTrackEventsStack = [];
        });
}

function sentry(page: string, account: Account) {
    const cid = getCookie('CLIENT_ID');
    const opts = account.thirdParty.sentry;
    const email = opts?.email;
    const accountId = opts?.accountId;
    const companyId = opts?.companyId;
    const companyName = opts?.companyName;
    const userType = opts?.userType;
    const needTrack = opts?.needTrack;

    setSiteRegion(account.siteRegion);

    if (needTrack && window.location.search.indexOf('noraven=1') < 0) {
        const browserInfo = Bowser.getParser(window.navigator.userAgent);
        const data = {
            id: accountId,
            email,
            os: browserInfo.getOSName(),
            browser: browserInfo.getBrowserName(),
            b_ver: browserInfo.getBrowserVersion(),
            account_id_cipher: accountId,
            company_id_cipher: companyId,
            company_name: companyName,
            user_type: userType,
        };

        if (cid) {
            Object.assign(data, { client_id: cid });
        }

        Raven.setUserContext(data);

        loadPsTracer(page);
    }
}

function RavenInsertMeta(category: string, action: string, attr?: TrackEventPayload) {
    if (!Raven.insertMeta) {
        return;
    }

    const trackData = {
        module: category,
        action,
        attr: _.merge({ region: getSiteRegion() }, attr),
    };

    Raven.insertMeta(trackData);
}

function unpushedTrackEventsStackCollection(trackData: ITrackData) {
    console.warn('ps-tracer not inited!');
    unpushedTrackEventsStack.push(trackData);
}

Raven.insertMeta = Raven.insertMeta ? Raven.insertMeta : unpushedTrackEventsStackCollection;

export {
    Raven,
    sentry,
    RavenInsertMeta,
};
